export const INCREMENT_PADDLE1_SCORE = 'INCREMENT_PADDLE1_SCORE'
export const INCREMENT_PADDLE2_SCORE = 'INCREMENT_PADDLE2_SCORE'
export const REQUEST_COLLISION_CHECK = 'REQUEST_COLLISION_CHECK'
export const REQUEST_UPDATE_GAME_STATE = 'REQUEST_UPDATE_GAME_STATE'
export const RESET_GAME = 'RESET_GAME'
export const SET_BALL_POSITION = 'SET_BALL_POSITION'
export const SET_BALL_RADIUS = 'SET_BALL_RADIUS'
export const SET_BALL_VELOCITY = 'SET_BALL_VELOCITY'
export const SET_GAME_PAUSED = 'SET_GAME_PAUSED'
export const SET_GAME_SPEED = 'SET_GAME_SPEED'
export const SET_PADDLE1_DIMENSIONS = 'SET_PADDLE1_DIMENSIONS'
export const SET_PADDLE1_POSITION = 'SET_PADDLE1_POSITION'
export const SET_PADDLE1_VELOCITY = 'SET_PADDLE1_VELOCITY'
export const SET_PADDLE2_DIMENSIONS = 'SET_PADDLE2_DIMENSIONS'
export const SET_PADDLE2_POSITION = 'SET_PADDLE2_POSITION'
export const SET_PADDLE2_VELOCITY = 'SET_PADDLE2_VELOCITY'
export const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE'


// WEBPACK FOOTER //
// ./src/store/types.js